import axiosClient from "./AxiosConfig";

const CategoryService = {

  async getAll() {
    return await axiosClient.get("/categories");
  },

  async getById(id) {
    return await axiosClient.get(`/categories/${id}`);
  },

  async create(category) {
    await axiosClient.post("/categories", category);
  },

  async update(category) {
    return await axiosClient.put("/categories", category);
  },

  async deleteById(id) {
    return await axiosClient.delete(`/categories/${id}`);
  }
};

export default CategoryService;
